import Modal from '@mui/material/Modal';
import "./creditNote.css"
import { openPopup } from '../../stateManagement/actions/popupActions';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getClientConfiguartions } from '../../services/updateTransaltionService';
import moment from 'moment';
import { submitCreditNote } from '../../features/deliveryConfirmation/DeliveryConfirmationService';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';
import { truncateToTwoDecimals } from '../dms_common/DmsUtils';


export const CreditNote = (props: { open: boolean, setOpen: any, returnId:string, returnAmount:number, creditAmount:number, outletCode:string }) => {

    const [amount, setAmount] = useState("");
    const [baseDetails, setBaseDetails] = useState<any>(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const [disableValidaity, setDisableValidaity] = useState(false);
    const [autoFillAmount, setAutoFillAmount] = useState(false);
    const navigate = useNavigate();

    const fetchConfigDetails = async()=>{
        let today = moment().format('DD-MM-YYYY');

        const reqBody = {
            "startDate": today,
            "endDate":"",
            "issueDate": today,
            "source":"portal",
        }
        
        try{
            const configs =(await getClientConfiguartions("credit_note_configuration")).data.features[0].domainValues;
            const autoFillAmount = configs.find((config:any)=>config.name == "autoFillAmount");
            if(autoFillAmount && autoFillAmount.value){
                setAutoFillAmount(true);
                setAmount(truncateToTwoDecimals(props.returnAmount-props.creditAmount));
            }
            const editValidity = configs.find((config:any)=>config.name == "editValidity");
            if(editValidity && editValidity.value){
                setDisableValidaity(false);
                reqBody.endDate = "";
                reqBody.startDate = "";
            }else{
                const days = configs.filter((config:any)=>config.name == "validity")[0];
                const endDate = moment().add(days, 'days').format('DD-MM-YYYY');
                reqBody.endDate = endDate;
            }
        }catch(exception){
            const endDate = moment().add(90, 'days').format('DD-MM-YYYY');
            reqBody.endDate = endDate;
        }
        setBaseDetails(reqBody);
    }

    useEffect(()=>{
        fetchConfigDetails()
    },[])
    
    useEffect(()=>{
        const startDate = moment(baseDetails?.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
        const endDate = moment(baseDetails?.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
        if(!isNaN(Number(amount)) && baseDetails && baseDetails.startDate && baseDetails.endDate && moment(endDate).isAfter(startDate) && Number(amount)>0){
            setIsDisabled(false);
        }else{
            setIsDisabled(true);
        }
    },[amount, baseDetails, props.returnId]);

    useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
      event.preventDefault();
      const activeElement = document.activeElement;
      if (
        activeElement?.tagName !== 'INPUT' &&
        activeElement?.tagName !== 'TEXTAREA' &&
        !isDisabled
      ) {
        issueCreditNote();
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [isDisabled, amount, baseDetails, props.returnId, props.outletCode]);

    const issueCreditNote = async()=>{
        setIsDisabled(true);
        try{
            if(Number(amount) > Number((props.returnAmount-props.creditAmount).toFixed(2))){
                openPopup("Error", "Insufficient Balance");
                return;
            }
            const reqBody = {...baseDetails};
            reqBody.returnId = props.returnId;
            reqBody.outletCode = props.outletCode;
            reqBody.supplier = JSON.parse(localStorage.authContext).user.loginId;
            reqBody.amount = Number(amount);
            reqBody.issueDate = moment(reqBody.issueDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
            reqBody.startDate = moment(reqBody.startDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
            reqBody.endDate = moment(reqBody.endDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
            const response = await submitCreditNote(reqBody);
            openPopup("Success","Your Credit Note has been issued successfully!",()=>{
                navigate(-1);
            });
        }catch(e){
            openPopup("Error","Something went wrong");
        }
        setIsDisabled(false);
    }

    return (
        <Modal
            open={props.open}
            onClose={() => { props.setOpen(false) }}
            aria-labelledby="credit-note-modal-title"
            aria-describedby="credit-note-modal-description"
        >
            <div className='credit_note_container'>
                <div className='credit_note_header'>Return ID: {props.returnId}</div>
                <div className='credit_note_body'>
                    <div className='credit_note_row_container'>
                        <div className='credit_note_row'>
                            <CreditNoteInput label="Issue Date" value={baseDetails?.issueDate} disabled={true}/>
                            <CreditNoteInput label="Return Value" suffix='₹' value={truncateToTwoDecimals(props.returnAmount).toString()} disabled={true}/>
                        </div>
                    </div>
                    <div className='credit_note_row_container'>
                        <div className="credit_note_row_header">Enter Return Value <div className='credit_note_hl'></div></div>
                        <div className='credit_note_row'>
                            <CreditNoteInput label="Credit Note Amount" suffix='₹' disclaimer={autoFillAmount ? undefined : `Balance Amount:${truncateToTwoDecimals(props.returnAmount-props.creditAmount)}`} value={amount} disabled={autoFillAmount} onChange={setAmount}/>
                        </div>
                    </div>
                    <div  className='credit_note_row_container'>
                        <div className="credit_note_row_header">Validity <div className='credit_note_hl'></div></div>
                        <div className='credit_note_row'>
                            <CreditNoteDateInput label="Start From" value={baseDetails?.startDate} onChange={(value)=>{
                                setBaseDetails({
                                    ...baseDetails,
                                    startDate: value
                                })
                            }} disabled={disableValidaity}/>
                            <CreditNoteDateInput label="Valid Till" value={baseDetails?.endDate} onChange={(value)=>{
                                setBaseDetails({
                                    ...baseDetails,
                                    endDate: value
                                })
                            }} disabled={disableValidaity}/>
                        </div>
                    </div>
                </div>
                <div className='credit_note_footer'>
                <button
                    className={`credit_note_submit_button${isDisabled ? "_disabled" : ""}`}
                    onClick={issueCreditNote}
                    disabled={isDisabled}
                >
                    <span className="credit_note_submit_button_text">
                        Issue Credit Note
                    </span>
                </button>
                </div>
            </div>
        </Modal>
    );
}

const CreditNoteInput = (props:{label:string,value:string,suffix?:string,disclaimer?:string, onChange?:React.Dispatch<React.SetStateAction<string>>, disabled:boolean})=>{
    return (
        <div className='credit_note_field_container'>
            <div className='credit_note_input_container'>
                <div className='credit_note_input_label'>{props.label}</div>
                <input
                    disabled={props.disabled}
                    value={(props.suffix ? (props.suffix+"  ") : "") + props.value}
                    onChange={(e) => {
                        const val = props.suffix ? e.target.value.replace(props.suffix+"  ","") : e.target.value;
                        if ( props.onChange && (val == "" || !isNaN(Number(val)))) {
                            props.onChange(val);
                        }
                    }}
                    className={'credit_note_input' + (props.disabled ? "_disabled" : "")}
                />
            </div>
            {props.disclaimer && <div className="credit_note_input_disclaimer">
                <span>*</span>
                {props.disclaimer}
            </div>}
        </div>
    );
}
const CreditNoteDateInput = (props:{label:string,value:string,suffix?:string,disclaimer?:string, onChange?:React.Dispatch<React.SetStateAction<string>>, disabled:boolean})=>{
    return (
        <div className='credit_note_field_container'>
            <div className='credit_note_input_container'>
                <div className='credit_note_input_label'>{props.label}</div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        className={'credit_note_date_input' + (props.disabled ? "_disabled" : "")}
                        value={props.value ? dayjs(props.value, "DD-MM-YYYY") : null}
                        onChange={(newValue) => {
                            props.onChange && props.onChange(newValue ? newValue.format("DD-MM-YYYY") : "");
                        }}
                        disabled={props.disabled}
                        renderInput={(params) => (
                            <TextField {...params} size="small"  fullWidth  />
                        )}
                        inputFormat="DD-MM-YYYY"
                    />
                </LocalizationProvider>
            </div>
            
        </div>
    );
}